import { generateCarleadCreationConfig } from '@wkda/funnel-utils';
import { defaultCarleadCreationConfig } from '../../../default/configuration';

export default generateCarleadCreationConfig(defaultCarleadCreationConfig);
